module.exports = __webpack_public_path__ + "img/codeFooter2.7cbe7606.png";